import React from "react";
import { components } from "react-select";

import { Visible } from "../../../core/components";
import { Loading, Select } from "../../../components";

const groupStyles = {
  borderTop: "1px solid #eeeeee",
  marginTop: -5,
};

const Group = (props) => (
  <div style={groupStyles}>
    <components.Group {...props} />
  </div>
);

const ActionButtonView = ({
  submitting,
  action,
  setAction,
  actionLabel,
  options,
  fieldName = "action_selector",
  update,
  disableUpdate = false,
  error,
  errorMsg,
  initiallyOpen,
  className = "",
}) => {
  return (
    <div
      className={`${
        className
          ? className
          : actionLabel === "Marketplace"
          ? "col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2"
          : `manage-request-item action-button ${className}`
      }`}
    >
      <Visible when={error}>
        <div className="error">
          {errorMsg || "Operation failed. Please try again."}
        </div>
      </Visible>

      <div
        className={`${
          actionLabel === "Marketplace"
            ? "field-group field-group-userSearchSelect "
            : `main ${action ? "action-selected d-flex" : ""}`
        }`}
      >
        <Select
          {...{
            className: `select-container  ${
              actionLabel === "Marketplace" ? "" : "order-action-selector"
            } ${action && "loaded"}`,
            placeholder: (
              <div className="listing-select__label">
                <Visible when={submitting}>
                  <Loading />
                </Visible>

                {!submitting ? actionLabel : ""}
              </div>
            ),
            options,
            onSelectionChange: (a) => setAction(a),
            field: { name: fieldName, value: action },
            form: { setFieldValue: () => {} },
            components: {
              Group,
            },
            autocomplete: "off",
            isSearchable: false,
            initiallyOpen,
            // react-select only: `initiallyOpen` (AssignReviewer) and the
            // `components.Group` divider have no ui/Select equivalent.
            legacy: true,
          }}
        />

        <Visible when={!!action}>
          <div
            className={`do-action ${disableUpdate ? "disabled" : ""}`}
            onClick={() => !disableUpdate && update()}
          >
            <Visible when={!submitting}>
              <img src="/assets/icons/next-2.svg"></img>
            </Visible>

            <Visible when={submitting}>
              <Loading type="small" />
            </Visible>
          </div>
        </Visible>
      </div>
    </div>
  );
};

export default ActionButtonView;
